export function isAppWebView(): boolean {
  return Boolean(window.ReactNativeWebView);
}

export function isLikelyMobileBrowser() {
  const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } };
  if (nav.userAgentData?.mobile) return true;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export type MobilePlatform = "ios" | "android" | "other";

export function getMobilePlatform(): MobilePlatform {
  const ua = navigator.userAgent || "";
  // iPadOS 13+ masquerades as macOS, so fall back to touch-point detection.
  const isIpadOS =
    /Macintosh/.test(ua) && typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/i.test(ua) || isIpadOS) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}
